import { useCallback } from 'react';
import { storeValue } from './helpers';
import { useAppDispatch } from '../store/hooks';
import { getUserProfile } from '../store/features/auth';

// Shared types for chat components
export interface UserCompanyDetails {
    logo: string;
    userId: string;
}

export interface ChatMessage {
    id: string | number;
    payload_type: number;
    payload: any;
    result?: any;
    conversation_id: string;
    is_local?: boolean;
    timestamp?: number;
}

// Shared utility functions
export const extractCompanyDetails = (res: any): UserCompanyDetails => {
    if (res?.data?.user?.id !== undefined) {
        storeValue('userId', res?.data?.user?.id);
    }
    return {
        logo: res?.data?.logo || '',
        userId: res?.data?.user?.id || '',
    };
};

export const useFetchUserDetails = () => {
    const dispatch = useAppDispatch();
    
    return useCallback(async (): Promise<UserCompanyDetails> => {
        try {
            const { getValue } = await import('./helpers');
            const companyId = getValue('companyId');
            const payload = { companyId, loader: false };
            const res = await dispatch(getUserProfile(payload)).unwrap();
            storeValue('canCreateJob', res.data.job_left);
            return extractCompanyDetails(res);
        } catch (error) {
            console.info('Error during fetching user details:', error);
            return { logo: '', userId: '' };
        }
    }, [dispatch]);
};
